import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  allData: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'GuestBillings',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getGuestBillingSuccess(state, action) {
      state.data = action.payload.data;
    },
    getAllGuestBillingSuccess(state, action) {
      state.allData = action.payload.data;
    },
    getGuestBillingFromBardSuccess(state, action) {
      state.pos = action.payload.data;
    },

    addOrUpdateGuestBilling(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      state.checkout.activeStep = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllGuestBilling() {
  return async () => {
    try {
      const response = await get(`GuestBilling`);
      if (response.status) {
        dispatch(slice.actions.getAllGuestBillingSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getGuestBillingFromBard(cardId) {
  return async () => {
    try {
      const response = await get(`getGuestBillingFromBard/${cardId}`);
      if (response.status) {
        dispatch(slice.actions.getGuestBillingFromBardSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGuestBilling() {
  return async () => {
    try {
      const response = await get(`GuestBilling`);
      if (response.status) {
        dispatch(slice.actions.getGuestBillingSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addGuestBilling(body) {
  return async () => {
    try {
      const response = await post(`GuestBilling`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuestBilling(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addGuestPayment(body) {
  return async () => {
    try {
      const response = await post(`GuestBillingPayment`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuestBilling(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateGuestBilling(body) {
  return async () => {
    try {
      const response = await put(`GuestBilling/${body?.id}`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuestBilling(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


// ----------------------------------------------------------------------

export function deleteGuestBilling(id) {
  return async () => {
    try {
      const response = await deleteMethod(`GuestBilling/${id}`);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuestBilling(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function removeCardFromCheckin(id) {
  return async () => {
    try {
      const response = await deleteMethod(`removeCardFromCheckin/${id}`);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuestBilling(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


// ----------------------------------------------------------------------

export function removePaidPayment(id) {
  return async () => {
    try {
      const response = await deleteMethod(`removePaidPayment/${id}`);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuestBilling(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
